import { Save } from '@mui/icons-material'
import LoadingButton from '@mui/lab/LoadingButton'
import { Box, SxProps, Tooltip, useMediaQuery } from '@mui/material'
import { FC } from 'react'
import { GENERIC_DISPLAY } from '../../../utils/genericDisplay'
import { useCanEditAnimal } from '../../../store/useCanEditAnimal'
import { theme } from '../../theme'

interface Props {
  isLoading: boolean
  disabled?: boolean
  sx?: SxProps
  fullWidthOnMobile?: boolean
}

export const AnimalCardSaveButton: FC<Props> = ({ isLoading, disabled, sx, fullWidthOnMobile = true }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const canEdit = useCanEditAnimal()

  return (
    <Tooltip title={canEdit ? '' : GENERIC_DISPLAY.doNotHavePermissionAsReader}>
      <Box sx={{ width: { xs: fullWidthOnMobile ? '100%' : 'auto', md: 'auto' } }}>
        <LoadingButton
          color="primary"
          variant="outlined"
          type="submit"
          loading={isLoading}
          disabled={!canEdit || disabled}
          sx={{
            minHeight: 42,
            px: 2.75,
            borderRadius: '999px',
            textTransform: 'none',
            fontSize: 13,
            fontWeight: 700,
            borderColor: 'rgba(122, 129, 151, 0.24)',
            backgroundColor: 'rgba(255, 255, 255, 0.72)',
            boxShadow: 'none',
            width: { xs: fullWidthOnMobile ? '100%' : 'auto', md: 'auto' },
            '&:hover': {
              borderColor: 'rgba(122, 129, 151, 0.35)',
              backgroundColor: 'white',
              boxShadow: 'none',
            },
            ...sx,
          }}
        >
          {!isMobile && <Save sx={{ marginRight: 1 }} />}
          Mettre à jour
        </LoadingButton>
      </Box>
    </Tooltip>
  )
}
